import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import { fuseBusinessFilter } from './businessFilter';

// Fuse Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'fuseinsurance',
  businessFilter: fuseBusinessFilter,
};
